import ajax from './ajax'
/**
 * 广告
 */
export const queryIdleAds = (params) => {
  return ajax({
    url: '/public/v1/idle/ads',
    params: params
  })
}
/**
 * 形式
*/
export const queryIdleTab = (params) => {
  return ajax({
    url: '/public/v1/idle/tab',
    params: params
  })
}
/**
 * 获取闲置筛选属性
 */
export const queryIdleAttrs = (params) => {
  return ajax({
    url: '/public/v1/idle/attr',
    params: params
  })
}

/**
 * 获取闲置列表
 */
export const queryIdleList = (params) => {
  return ajax({
    url: '/public/v1/idle/list',
    params: params
  })
}

/**
 * 获取闲置详情
 */
export const queryIdleDetail = (params) => {
  return ajax({
    url: '/public/v1/idle/detail',
    params: params
  })
}

/**
 * 用户购买-出售
 */
export const doConnect = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/connect',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户取消
 */
export const modifyConnect = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/modifyConnect',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户查询列表
 */
export const queryUserList = (params) => {
  return ajax({
    url: '/public/v1/idle/userList',
    params: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 购买记录
 */
export const queryItemConnects = (params) => {
  return ajax({
    url: '/public/v1/idle/itemConnects',
    params: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 购买记录
 */
export const queryUserConnects = (params) => {
  return ajax({
    url: '/public/v1/idle/userConnects',
    params: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户查询详情
 */
export const queryUserDetail = (params) => {
  return ajax({
    url: '/public/v1/idle/userDetail',
    params: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户新增
 */
export const createIdle = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/create',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户修改
 */
export const modifyIdle = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/modify',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户修改
 */
export const modifyIdleField = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/field',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户删除
 */
export const deleteIdle = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/delete',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户注册
 */
export const addUser = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/addUser',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户修啊给i
 */
export const modUser = (params) => {
  return ajax({
    method: 'post',
    url: '/public/v1/idle/modUser',
    data: {
      ...params,
      withToken: 1
    }
  })
}

/**
 * 用户查询
 */
export const queryUser = (params) => {
  return ajax({
    method: 'get',
    url: '/public/v1/idle/queryUser',
    params: {
      ...params,
      withToken: 1
    }
  })
}



// WEBPACK FOOTER //
// ./src/axios/idle.js